import { $win } from './utils'

import currentYear from './current-year';
import adaUI from './ada';
import headerUI from './header';
import menuUI from './menu';
import cookiesUI from './cookie';
import subscribeUI from './subscribe';
import personalizationUI from './modules/personalizationUI';
import initBookingMask from './BookingMask';

;(function(window, document, $) {
	initBookingMask();

	// Offer buttons can trigger the booking mask (in specific case)
	$(document).on('click', '.js-booking-offer', function(e){
		const target = this.getAttribute('data-target');

		// Normal links should just open
		if (/^(mailto:|tel:|http|\/)/.test(target)) {
			window.open(target,'_blank');
			return;
		}

		$('.booking-mask').find('input[name="promoCode"]').val(target).parent().addClass('filled');
		openBMWithOverlay();
	});

	function openBMWithOverlay() {
		$('.booking-mask__body').slideDown();
		$('.booking-mask').addClass('active');
	}

	$('.js-move').each(function() {
		const $this = $(this);
		const $target = $($this.data('target'));

		if ($this.hasClass('no-mobile')) {
			if ($win.width() > 767) {
				$target.append($this);
			}
		} else {
			$target.append($this);
		}

	});

	$('a[href^="tel"]').each(function() {
		const linkHref = $(this).attr('href');

		$(this).attr('href', linkHref.replace(/ /igm, ''));
	});

	$('.js-trim-decimals').each(function() {
		const number = Math.trunc($(this).text());

		$(this).text(number);
	});

	$('.js-add-commas').each(function() {
		const number = $(this).text();
		const length = number.length;

		if ( length > 3 ) {
			$(this).text(number.slice(0, length - 3) + ',' + number.slice(length - 3,length));
		}
	});

	if ($('.js-date').length) {
		import(/* webpackChunkName: "date-ui" */ './date-ui.js').then(module => {
			module.default();
		});
	}

	$('.js-scroll-to-top').on('click', function(event) {
		event.preventDefault();

		$('html, body').animate({
			scrollTop: 0
		});
	});

	$('.js-bold-title').each(function() {
		const $this = $(this);
		const text = $this.text();

		if (text.length) {
			const firstWord = text.split(' ')[0];

			$this.html(text.replace(firstWord, `<strong>${firstWord}</strong>`));
		}
	});

	$('.form__inner').each(function() {
		const $title = $(this).find('.form__heading').first();

		$title.insertBefore($(this).prev());
	});

	$('.form').each(function() {
		const $this = $(this);
		const hasAccordions = $this.find('.form__section').length;

		if (hasAccordions) {
			const submitButton = $this.find('.form__btn').closest('.col-md-12');

			submitButton.appendTo($this.find('.form__section').last().find('.row').first())
		}
	})

	import(/* webpackChunkName: "fullsize" */ './fullsize.js').then(module => {
		module.default();
	});

	if ($('.js-slider').length) {
		import(/* webpackChunkName: "sliders" */ './sliders.js').then(module => {
			module.default();
		});
	}

	if ($('.js-filter').length || $('.js-filter-select').length) {
		import(/* webpackChunkName: "filtersUI" */ './filtersUI.js').then(module => {
			module.default()
		});
	}

	if ($('.js-custom-select').length) {
		import(/* webpackChunkName: "select" */ './select.js').then(module => {
			module.default();
		});
	}

	if ( $('.js-gallery').length ) {
		import(/* webpackChunkName: "gallery" */ './gallery.js').then(module => {
			module.default()
		});
	}

	adaUI();

	// Add js-year-container class where you want to print the current year
	currentYear();

	if ($('[data-shave]').length) {
		import(/* webpackChunkName: "shave-ui" */ './shave-ui.js').then(module => {
			module.default();
		});
	}

	if ($('[data-read-more]').length) {
		import(/* webpackChunkName: "read-more-ui" */ './read-more-ui.js').then(module => {
			module.default();
		});
	}

	if ($('.map').length) {
		import(/* webpackChunkName: "maps-ui" */ './maps-ui.js').then(module => {
			module.default();
		});
	}

	if ($('.js-form').length) {
		import(/* webpackChunkName: "forms-ui" */ './forms-ui.js').then(module => {
			module.default();
		});
	}

	headerUI();

	menuUI();

	$win.on('load', function() {
		import(/* webpackChunkName: "booking" */ './booking.js').then(module => {
			module.default();
		});
	});

	if ($('.js-filter-pagination').length) {
		import(/* webpackChunkName: "filter-pagination" */ './filter-pagination.js').then(module => {
			module.default();
		});
	}

	if ($('.js-datepicker-forms').length) {
		import(/* webpackChunkName: "range-picker-forms" */ './range-picker-forms.js').then(module => {
			module.default();
		});
	}

	cookiesUI();

	subscribeUI();

	personalizationUI();
})(window, document, window.jQuery);
